/**
 * Contact Page Component
 * 
 * Main component that orchestrates the entire contact page layout.
 * This component brings together all contact-related sections including:
 * - Contact information (email, phone, location, social media)
 * - Frequently Asked Questions (FAQ)
 * - Business hours schedule
 * - Interactive Google Maps location
 * 
 * @component
 * @returns {JSX.Element} The complete contact page layout
 */

import React from 'react';
import ContactInfo from '../../components/contact/contact-info/contact-info';
import ContactFAQ from '../../components/contact/contact-faq/contact-faq'; // FAQ = Frequently Asked Questions (Preguntas Frecuentes)
import ContactSchedule from '../../components/contact/contact-schedule/contact-schedule';
import ContactMap from '../../components/contact/contact-map/contact-map';
import './contact-style.css';

const Contacto = () => {
  return (
    <div className="contacto">
      {/* Main container for all contact page content */}
      <div className="contacto__container">
        {/* Left column: contact information and FAQ (Frequently Asked Questions) */}
        <div className="contacto__content">
          <ContactInfo />
          <ContactFAQ /> {/* Frequently Asked Questions section */}
        </div>
        {/* Right column: business hours and map */}
        <ContactSchedule />
        <ContactMap />
      </div>
    </div>
  );
};

export default Contacto;
